// import axios from 'axios';
// const API_URL = process.env.REACT_APP_BASE_URL || "https://findagram.ca/api/";
// const ApiClient = () => {
  
//     const instance = axios.create({
//         baseURL: API_URL ,
//         headers: {
//         'Content-Type':'application/json',
//     }
//     });
//     const token = localStorage.getItem('accessToken');
//         if (token) {
       
//         instance.defaults.headers.common['Authorization'] =  {token};
//         } else {
//           delete instance.defaults.headers.common['Authorization'];
//         }
//     return instance;
// };
// export default ApiClient;



// import axios from 'axios';

// const API_URL = process.env.REACT_APP_BASE_URL || "https://findagram.ca/api/";

// const instance = axios.create({
//   baseURL: API_URL,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// instance.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('accessToken');
//     if (token && !config.skipAuth) {
//       config.headers['Authorization'] = `Bearer ${token}`;
//     }

//     return config;
//   },
//   (error) => Promise.reject(error)
// );





// export default instance;



import axios from 'axios';

// Define API base URL
const API_URL = process.env.REACT_APP_BASE_URL || "https://findagram.ca/api/";

// Create Axios instance
const instance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: Add Authorization header if token is present
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token && !config.skipAuth) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: Handle 401 errors (unauthorized)
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("authUser");

      // Ensure window is defined (in case of SSR or testing environments)
      if (typeof window !== "undefined") {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default instance;


